import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/entities/session/model/authStore';
import { ROUTES } from '@/shared/config/constants';

export function ProtectedRoute({ children }) {
  const { token } = useAuthStore();
  const location = useLocation();

  if (!token) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return children;
}
